import { FormattedMessage } from 'react-intl';
import styles from './InvalidElement.module.scss';

import { Icon } from '@ets/design-system';

import EditorManager from 'Editor/services/EditorManager';
import { ELEMENTS } from 'Editor/services/consts';
import { BaseBlockElement } from '../../BaseViewBuilder';
import { Root } from 'react-dom/client';
import ReactUtils from '_common/utils/ReactUtils';

const InvalidElementComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <Icon disabled icon="triangle-exclamation" size="4" testId="warning" />
      </div>
      <span className={styles.contentWrapper}>
        <span className={styles.info}>
          <FormattedMessage id="CUSTOM_ELEMENT_WARNING_CONTENT" />
        </span>
      </span>
    </div>
  );
};

export class InvalidElement extends BaseBlockElement {
  static TIMEOUTS: { [index: string]: NodeJS.Timeout } = {};
  private rootReactContainer?: Root;
  private nodeId?: string;
  private wrapper?: HTMLElement;

  connectedCallback() {
    super.connectedCallback();
  }

  preRender(isBlock: boolean= false) {
    super.preRender();
    if (isBlock) {
      this.buildBlockElement();
    } else {
      this.buildInlineElement();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    ReactUtils.unmountReactComponent(this.rootReactContainer);
    this.clearForceUpdateTimeout();
  }

  get selectableContent() {
    return this.wrapper?.childNodes[0] || null;
  }

  setElementIdToCheck(nodeId: string) {
    this.nodeId = nodeId;
    this.setAttribute('enclosed_element', nodeId);

    // this._setForceUpdateTimeout();
  }

  private clearForceUpdateTimeout() {
    if (this.nodeId) {
      if (InvalidElement.TIMEOUTS[this.nodeId]) {
        clearTimeout(InvalidElement.TIMEOUTS[this.nodeId]);
        delete InvalidElement.TIMEOUTS[this.nodeId];
      }
    }
  }

  private setForceUpdateTimeout() {
    this.clearForceUpdateTimeout();
    if (this.nodeId) {
      InvalidElement.TIMEOUTS[this.nodeId] = setTimeout(() => {
        if (this.nodeId) {
          EditorManager.getInstance().forceUpdate(this.nodeId);
        }
      }, 1000);
    }
  }

  buildInlineElement() {
    this.setAttribute('spellcheck', 'false');
    this.setAttribute('class', styles.inline);

    this.appendChild(document.createTextNode('INVALID ELEMENT'));
  }

  buildBlockElement() {
    this.setAttribute('spellcheck', 'false');
    this.setAttribute('class', styles.block);

    this.rootReactContainer = ReactUtils.createReactRoot(this);
    ReactUtils.renderReactComponent(<InvalidElementComponent />, this.rootReactContainer);
  }
}

if (!window.customElements.get(ELEMENTS.InvalidElement.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.InvalidElement.IDENTIFIER, InvalidElement);
}
